<script setup lang="ts">
import { computed } from 'vue'
import { storeToRefs } from 'pinia'

import { usePageStore } from '../../stores/page'

const pageStore = usePageStore()
const { disclaimerOpen } = storeToRefs(pageStore)
const { toggleAffiliateDisclaimer } = pageStore

const ariaLabel = computed(() => disclaimerOpen.value ? 'Affiliate Disclaimer schliessen' : 'Affiliate Disclaimer öffnen')
const ariaExpanded = computed(() => disclaimerOpen.value ? 'true' : 'false')
</script>

<template>
  <div id="bx-disclaimer-affiliate"
       class="bx-content bx-disclaimer bx-typo--affiliate-disclaimer"
       :class="{'bx-js-affdi-hide': !disclaimerOpen}"
       tabindex="0"
       data-tc="affiliate-disclaimer"
       :aria-label="ariaLabel"
       role="button"
       aria-controls="bx-aria-affdi"
       :aria-expanded="ariaExpanded"
       @click="toggleAffiliateDisclaimer"
       @keyup.enter="toggleAffiliateDisclaimer">
    <div class="bx-disclaimer__headline">
      <span>Hinweise zu den Affiliate-Links</span>
      <svg class="icon icon-arrow_toggle">
        <use href="#arrow_toggle" />
      </svg>
    </div>
    <p id="bx-aria-affdi">
      Die genannten Produkte und Angebote wurden von unserer Redaktion persönlich und unabhängig ausgewählt. Bei einem Kauf oder Abschluss über einen der verlinkten Anbieter (Affiliate-Link bzw. mit <span class="bx-disclaimer__bag">Symbol</span> gekennzeichnet) erhalten wir eine geringfügige Provision. Die redaktionelle Auswahl und Beschreibung der Produkte und Angebote wird dadurch nicht beeinflusst.
    </p>
  </div>
</template>
